// ##### 25-04-24 Komarov
import axios from 'axios';
import { isServer } from '../../server/helpers/browserDetector';

function splitStringByBlocks(str) {
  const result = [];
  let currentBlock = '';
  let isDigitBlock = null;

  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    const isDigit = /\d/.test(char);

    if (currentBlock === '') {
      currentBlock = char;
      isDigitBlock = isDigit;
    } else if (isDigit === isDigitBlock) {
      currentBlock += char;
    } else {
      result.push(currentBlock);
      currentBlock = char;
      isDigitBlock = isDigit;
    }
  }

  if (currentBlock !== '') {
    result.push(currentBlock);
  }

  return result;
}

async function isLinuxUserExist(user) {
  return await axios
    .post(`${process.env.REACT_APP_URL}/user_check`, {
      user,
    })
    .then(async res => {
      return !!(await res.data);
    })
    .catch(error => {
      console.error(error);
      return false;
    });
}

function isTextIn(str) {
  const result = str === 'in';
  if (!result) {
    console.error('Помилка: Неправильний текст.');
  }
  return result;
}

function isTextDev(str) {
  const result = str === 'dev';
  if (!result) {
    console.error('Помилка: Неправильний текст.');
  }
  return result;
}

function testCount(actual, expected) {
  const result = actual === expected;
  if (!result) {
    console.error('Помилка: Кількість блоків не підходить.');
  }
  return result;
}

// ##### Komarov 2025-07-03
/* function isEnoughChars(str) {
  const result = str.length >= 2;
  if (!result) {
    console.error("Помилка: Повинно бути не менше 2 символів.");
  }
  return result;
} */

/* function isAlphaNumeric(str) {
  const result = /^[a-zA-Z0-9]+$/.test(str);
  if (!result) {
    console.error("Помилка: Повинні бути тільки латинські букви або цифри.");
  }
  return result;
} */

function isAlpha(str) {
  const result = /^[a-zA-Z]+$/.test(str);
  if (!result) {
    console.error('Помилка: Повинні бути тільки латинські букви.');
  }
  return result;
}

function areCharsOnly(strArray) {
  for (let i = 0; i < strArray.length; i += 2) {
    if (!isAlpha(strArray[i])) return false;
  }
  return true;
}

function checkEquationReversedStringsIntegerResultDistinctNonZero(
  str_a,
  str_b,
  str_c,
  str_d,
  str_e,
  str_f
) {
  // ##### 25-04-24 Komarov: приводим эти строковые значения к типу число, потому что со строками предстоящие ниже арифметические операции будут выполняться по-другому, чем с числами
  const a = parseInt(str_a);
  const b = parseInt(str_b);
  const c = parseInt(str_c);
  const d = parseInt(str_d);
  const e = parseInt(str_e);
  // ##### 25-04-24 Komarov: а это значение нам и нужно в строковом виде, потому что мы им манипулируем как строкой (переворачиваем наоборот, что в случае цифры, оканчивающейся на ноль, привело бы к искажению промежуточного контрольного результата и поломке системы проверки соотношения логина и пароля)
  const f = str_f;
  // Перевірка на нуль
  if (a === 0 || b === 0 || c === 0 || d === 0 || e === 0 || f === 0) {
    console.error('Помилка: Аргументи не повинні дорівнювати нулю.');
    return false;
  }

  // Перевірка на унікальність аргументів
  const args = [a, b, c, d, e, f];
  const uniqueArgs = [...new Set(args)];
  if (args.length !== uniqueArgs.length) {
    console.error('Помилка: Всі аргументи повинні бути різними.');
    return false;
  }

  // Перевірка ділення на нуль (хоча попередні умови вже виключають e === 0)
  if (e === 0) {
    console.error('Помилка: Ділення на нуль недопустиме.');
    return false;
  }

  const leftSideResult = ((a + b - c) * d) / e;
  // ##### 25-04-24 Komarov: Правила соотношения логина и пароля:
  /*
  1.  Пароль состоит из блоков букв (от 2 букв блок) и цифр. Блоки букв и цифр пароля чередуются между собой.
  Проверка: по краям должны быть блоки из букв.
  2.  Блоков цифр должно быть 5.
  Проверка: общее количество блоков должно быть 11.
  3.  Логин состоит из блоков букв (от 2 букв блок) и цифр. Блоки букв и цифр чередуются между собой.
  Проверка: по краям должны быть блоки из букв
  4.  Блоков цифр должно быть 3.
  Проверка: общее количество блоков должно быть 7.
  5.  Между паролем и логином должно выполняться соотношение: 1-е число + 2-е число - 3-е число \* 4-е число / 5-е число пароля должны давать в результате среднее число логина, прочитанное наоборот (справа налево).
  6.  4-й блок символов пароля - текст "in", 5-й блок - текст "dev".
  7.  6-й блок символов пароля - это имя пользователя Линукс на сервере сайта.
  8.  Блоки символов должны состоять только из букв.

  При успешном входе в режим Разработчика в Консоли браузера выводится спец. информация (отладочная и др.).
*/

  // Пример построения логина и пароля (примерно):
  // 056 - число, которое будет записано в середине логина (650 наоборот)
  // 500 * 10 = 5000
  // 5000 / 5 = 1000
  // 1000 + 400 = 1400
  // 1400 - 300 = 1100
  // (((300 + 1400) - 400) * 5) / 10 = 650
  // (((a + b) - c) * d) / e
  // login: aa123bb056cc321dd (blocks: aa 123 bb 056 cc 321 dd)
  // password: aa300bb1400cc400in5dev10alexander (blocks: aa 300 bb 1400 cc 400 in 5 dev 10 alexander)

  // Перевіряємо, чи є результат цілим числом
  if (!Number.isInteger(leftSideResult)) {
    console.error('Помилка: Не ціле число.');
    return false;
  }

  const reversedFString = String(f).split('').reverse().join('');
  return String(leftSideResult) === reversedFString;
}

// ##### Komarov 2025-08-26: синхронная функция для проверки значения в localStorage без проверки пользователя на сервере (функция для использования в местах, где не инициировано Redux Store (за границами Компонента App клиентского приложения))
export const isDeveloperMode = (options) => {
  // options: { cookieString?: string }
  // ##### 25-04-28 Komarov
  if (isServer) {
    const cookieString = options && typeof options.cookieString === 'string' ? options.cookieString : '';
    if (!cookieString) return false;
    try {
      const hasDev = cookieString
        .split(';')
        .map(s => s.trim())
        .some(s => s === 'devMode=1' || s.startsWith('devMode=1'));
      return !!hasDev;
    } catch {
      return false;
    }
  }
  // ##### Komarov 2025-08-26: Поддержка cookie-флага devMode
  try {
    const cookie = typeof document !== 'undefined' ? document.cookie : '';
    if (cookie) {
      const devCookie = cookie
        .split(';')
        .map(s => s.trim())
        .find(s => s.startsWith('devMode='));
      if (devCookie && devCookie.split('=')[1] === '1') {
        return true;
      }
    }
  } catch {
    // ignore
  }
  // ##### 25-04-24 Komarov: Проверяем, находится ли пользователь в режиме Разработчика
  const usernamePassword =
    localStorage.getItem('devKey') && localStorage.getItem('devKey').split('+');
  const username = usernamePassword && usernamePassword[1];
  const password = usernamePassword && usernamePassword[0];
  if (!username || !password) return false;
  // Если devKey присутствует, но cookie нет — синхронизируем cookie
  try {
    const hasDevCookie = (document.cookie || '').split(';').map(s => s.trim()).some(s => s === 'devMode=1');
    if (!hasDevCookie) {
      document.cookie = `devMode=1; Path=/; Max-Age=604800`;
    }
  } catch {
    // ignore
  }
  // Разделяем логин на блоки
  const loginParts = splitStringByBlocks(username);
  // Разделяем пароль на блоки
  const passwordParts = splitStringByBlocks(password);
  // Проверяем, что по краям логина буквы
  if (!isAlpha(loginParts[0]) || !isAlpha(loginParts[loginParts.length - 1])) {
    return false;
  }
  // Проверяем, что количество блоков в логине 7
  if (!testCount(loginParts.length, 7)) {
    return false;
  }
  // Проверяем, что по краям пароля буквы
  if (
    !isAlpha(passwordParts[0]) ||
    !isAlpha(passwordParts[passwordParts.length - 1])
  ) {
    return false;
  }
  // Проверяем, что количество блоков в пароле 11
  if (!testCount(passwordParts.length, 11)) {
    return false;
  }
  // Проверяем, что блоки символов в логине и пароле состоят только из букв
  if (!areCharsOnly(loginParts) || !areCharsOnly(passwordParts)) {
    return false;
  }
  // Проверяем соотношение чисел между логином и паролем
  if (
    !checkEquationReversedStringsIntegerResultDistinctNonZero(
      passwordParts[1],
      passwordParts[3],
      passwordParts[5],
      passwordParts[7],
      passwordParts[9],
      loginParts[3]
    )
  ) {
    console.error('Співвідношення невірне');
    return false;
  }
  // Проверяем, что 4-й блок символов пароля - текст "in", 5-й блок - текст "dev"
  if (!isTextIn(passwordParts[6]) || !isTextDev(passwordParts[8])) {
    return false;
  }
  // Все проверки пройдены, возвращаем true
  return true;
};

// TODO: Сделать проверку логина и пароля согласно постановке
const isDeveloperLogin = async (username, password) => {
  if (!username || !password) return false;
  // Разделяем логин на блоки
  const loginParts = splitStringByBlocks(username);
  // Разделяем пароль на блоки
  const passwordParts = splitStringByBlocks(password);
  // Проверяем наличие пользователя в Linux, потом проверяем остальные критерии соотношения логина и пароля
  const userExists = await isLinuxUserExist(
    passwordParts[passwordParts.length - 1]
  );
  if (!userExists) {
    console.error('Помилка: Такого користувача немає.');
    return false; // не developer's login
  }
  // Проверяем, что по краям логина буквы
  if (!isAlpha(loginParts[0]) || !isAlpha(loginParts[loginParts.length - 1])) {
    return false;
  }
  // Проверяем, что количество блоков в логине 7
  if (!testCount(loginParts.length, 7)) {
    return false;
  }
  // Проверяем, что по краям пароля буквы
  if (
    !isAlpha(passwordParts[0]) ||
    !isAlpha(passwordParts[passwordParts.length - 1])
  ) {
    return false;
  }
  // Проверяем, что количество блоков в пароле 11
  if (!testCount(passwordParts.length, 11)) {
    return false;
  }
  // Проверяем, что блоки символов в логине и пароле состоят только из букв
  if (!areCharsOnly(loginParts) || !areCharsOnly(passwordParts)) {
    return false;
  }
  // Проверяем соотношение чисел между логином и паролем
  if (
    !checkEquationReversedStringsIntegerResultDistinctNonZero(
      passwordParts[1],
      passwordParts[3],
      passwordParts[5],
      passwordParts[7],
      passwordParts[9],
      loginParts[3]
    )
  ) {
    console.error('Співвідношення невірне');
    return false;
  }
  // Проверяем, что 4-й блок символов пароля - текст "in", 5-й блок - текст "dev"
  if (!isTextIn(passwordParts[6]) || !isTextDev(passwordParts[8])) {
    return false;
  }
  // Все проверки пройдены, возвращаем true
  return true;
};

export default isDeveloperLogin;
